import api from "@/assets/js/api"; // 引入 API 模組

export default {
  data() {
    return {
      newsList: [], // 儲存從 API 獲取的新聞列表
      currentNewsIndex: 0, // 當前顯示的起始索引
    };
  },
  computed: {
    // 計算目前可見的兩則新聞
    visibleNews() {
      return this.newsList.slice(this.currentNewsIndex, this.currentNewsIndex + 3);
    },
  },
  methods: {
    goToNewsPage(newsId) {
      this.$router.push({
        path: "/news",
        query: { id: newsId }, // 将新闻 ID 作为 query 参数传递
      });
    },
    // 上一則新聞
    previousNews() {
      if (this.currentNewsIndex > 0) {
        this.currentNewsIndex -= 1;
      }
    },
    // 下一則新聞
    nextNews() {
      if (this.currentNewsIndex < this.newsList.length - 2) {
        this.currentNewsIndex += 1;
      }
    },
    // 從 API 獲取最新的 6 則新聞
    async fetchNews() {
      try {
        const response = await api.get("/news/latest", { params: { limit: 6 } }); // 調用 API
        this.newsList = response.data.map((item) => ({
          id: item.Id,
          date: `${item.Starttime} ~ ${item.Endtime}`, // 格式化日期範圍
          title: item.Title, // 標題
          category: item.Category,
          image: require(`@/assets/picture/News/${item.Image}`), // 動態加載圖片路徑
        }));
      } catch (error) {
        console.error("無法獲取新聞資料：", error);
      }
    }
  },
  mounted() {
    this.fetchNews(); // 組件掛載時自動調用
  },
};
